import {func} from 'prop-types';
import React from 'react';

import ZoomToButton from '@components/common/ZoomToButton';

const ZoomToFeatureButton = ({onClick}) => {
  return <ZoomToButton tooltipText="Zoom to feature" onClick={onClick} />;
};

ZoomToFeatureButton.propTypes = {
  onClick: func,
};

export default ZoomToFeatureButton;
